import { useTranslation } from '@jupiter/plugin-runtime/i18n';
import { useLocation } from 'react-router-dom';
import { getQuery } from '@i18n-ecom/lib/dist/commonjs/url';
import { CODE_SUCCESS } from '@features/constants/network';
import { RoleType } from '@/constants';
import { usePolicyModel } from '../models';

export interface UseContentOptions {
  type: RoleType;
}

export const useContent = ({ type }: UseContentOptions) => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const { menu, list, loadPage } = usePolicyModel();
  const contentId = +(
    getQuery(location.search, 'content_id')?.toString() || ''
  );
  const item = menu[type]?.length ? list[contentId] : undefined;
  const fetch = (id: number, pageNumber: number) => {
    const repo = list[id] || {};
    const bucket = repo.bucket || {};
    const pageStr = `${i18n.language}_${pageNumber}`;

    if (!bucket[pageStr]) {
      return loadPage(id, pageNumber).then(res => ({
        error: res?.code !== CODE_SUCCESS,
        total: res?.data?.total || repo.total,
        items: res?.data?.learning_info || [],
      }));
    } else {
      loadPage(id, pageNumber);
    }

    return {
      total: repo.total || 0,
      items: bucket[pageStr] || [],
    };
  };

  return {
    item,
    fetch,
  };
};
